import { AudioMentionNew } from "@/types/MentionCard";
import { AudioSlider } from "@components/ui/audio-slider";
import { useMediaSelector } from "media-chrome/react/media-store";

export default function AudioTrack({
  mentions,
}: {
  mentions: AudioMentionNew[];
}) {
  const mediaCurrentTime =
    useMediaSelector((state) => state.mediaCurrentTime) ?? 0;
  const mediaDuration = useMediaSelector((state) => state.mediaDuration) ?? 0;

  return (
    <AudioSlider
      disabled
      min={0}
      step={0.1}
      className="w-full"
      withTrack={false}
      withThumb={!!mediaCurrentTime}
      value={
        mediaCurrentTime
          ? [mediaCurrentTime]
          : [mentions[0].indices_metadata?.start_time ?? 0]
      }
      max={Number.isNaN(mediaDuration) ? 0 : mediaDuration}
    />
  );
}
